import { render, staticRenderFns } from "./time-series-area-select.vue?vue&type=template&id=61af3d2c&scoped=true&"
import script from "./time-series-area-select.vue?vue&type=script&lang=ts&"
export * from "./time-series-area-select.vue?vue&type=script&lang=ts&"
import style0 from "./time-series-area-select.vue?vue&type=style&index=0&id=61af3d2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61af3d2c",
  null
  
)

export default component.exports